import React from 'react';

export default ({width, height}) => {
  let style={width, height}
  return (
    <div style={style} />
  );
};



// WEBPACK FOOTER //
// ./src/components/common/Padding.js